import { formatInTimeZone } from 'date-fns-tz';

const LIMA_TZ = 'America/Lima';

export interface ShiftMark {
  kind: 'ingreso' | 'salida';
  deviceTs: string;
  /** true si todavía está en la cola local (no subió al servidor). */
  pending: boolean;
}

export interface ShiftState {
  hasIngreso: boolean;
  hasSalida: boolean;
  ingresoTs: string | null;
  salidaTs: string | null;
  hasPending: boolean;
  label: string;
}

function earliest(marks: ShiftMark[], kind: 'ingreso' | 'salida'): ShiftMark | null {
  const ofKind = marks.filter((m) => m.kind === kind);
  if (ofKind.length === 0) return null;
  return ofKind.reduce((a, b) => (new Date(a.deviceTs) <= new Date(b.deviceTs) ? a : b));
}

const hhmmLima = (ts: string): string => formatInTimeZone(new Date(ts), LIMA_TZ, 'HH:mm');

/** Combina las asistencias del servidor con la cola local en un solo estado del turno. */
export function computeShiftState(marks: ShiftMark[]): ShiftState {
  const ingreso = earliest(marks, 'ingreso');
  const salida = earliest(marks, 'salida');
  const hasPending = marks.some((m) => m.pending);

  let base: string;
  if (ingreso && salida) base = 'Completo';
  else if (ingreso) base = `Ingreso ${hhmmLima(ingreso.deviceTs)}`;
  else if (salida) base = `Salida ${hhmmLima(salida.deviceTs)}`;
  else base = 'Sin marcar';

  return {
    hasIngreso: ingreso !== null,
    hasSalida: salida !== null,
    ingresoTs: ingreso?.deviceTs ?? null,
    salidaTs: salida?.deviceTs ?? null,
    hasPending,
    label: hasPending ? `${base} · pendiente de subir` : base,
  };
}
